module.exports = __webpack_public_path__ + "media/images/front/brands/avant_garde/card-b2d1510f956d190ac1564632eb637695.jpg";